import { Controller } from "@hotwired/stimulus";

const UNVERIFIED_LIMIT_YEN = 2_000_000; // 200万円

class ApplicationPurchaseController extends Controller {
  static targets = ['total', 'unitField', 'limitWarning', 'limitInfo']
  static values = { price: Number, purchased: Number }

  connect() {
    this.setTotal(this.unitFieldTarget.value);
    this.checkLimit(this.unitFieldTarget.value);
  }

  changeUnit(event) {
    this.setTotal(event.target.value);
    this.checkLimit(event.target.value);
  }

  setTotal(unit) {
    this.totalTarget.textContent = `${unit}枚`;
  }

  checkLimit(unit) {
    // 上限UI(limitWarning/limitInfo)は本人確認未完了ユーザーにのみ描画される。
    // 本人確認済みでは target が存在せず、ここで no-op になる（＝上限なし）。
    if (!this.hasLimitUi) return;

    const totalYen = this.purchasedValue + (Number(unit) * this.priceValue);
    const exceeded = totalYen > UNVERIFIED_LIMIT_YEN;

    if (this.hasLimitWarningTarget) this.limitWarningTarget.style.display = exceeded ? '' : 'none';
    if (this.hasLimitInfoTarget)    this.limitInfoTarget.style.display    = exceeded ? 'flex' : 'none';
  }

  // 本人確認未完了ユーザーだけ上限UIを持つ
  get hasLimitUi() {
    return this.hasLimitWarningTarget || this.hasLimitInfoTarget;
  }
}

// Registered in admin.js
export { ApplicationPurchaseController };
